import { createAsyncThunk } from '@reduxjs/toolkit';

import { statisticsService } from 'library/api/statisticsService';
import type { Statistics } from 'library/models/statistics';
import type { reqStatistics } from 'library/types/statistics';

export const getProgramsStatistics = createAsyncThunk<
	Statistics[],
	reqStatistics,
	{ rejectValue: string }
>('statistics/programs', async ({ mode, date }, { rejectWithValue }) => {
	try {
		const response =
			mode === 'year'
				? await statisticsService.getProgramsYearStatistics(date)
				: await statisticsService.getProgramsMounthStatistics(date);
		return response.data;
	} catch (e) {
		throw rejectWithValue('Не удалось загрузить статистику видеопрограмм.');
	}
});

export const getEventsStatistics = createAsyncThunk<
	Statistics[],
	reqStatistics,
	{ rejectValue: string }
>('statistics/events', async ({ mode, date }, { rejectWithValue }) => {
	try {
		const response =
			mode === 'year'
				? await statisticsService.getEventsYearStatistics(date)
				: await statisticsService.getEventsMounthStatistics(date);

		return response.data;
	} catch (e) {
		throw rejectWithValue('Не удалось загрузить статистику мероприятий.');
	}
});

export const getConsultationsStatistics = createAsyncThunk<
	Statistics[],
	reqStatistics,
	{ rejectValue: string }
>('statistics/consultations', async ({ mode, date }, { rejectWithValue }) => {
	try {
		const response =
			mode === 'year'
				? await statisticsService.getConsultationsYearStatistics(date)
				: await statisticsService.getConsultationsMounthStatistics(date);

		return response.data;
	} catch (e) {
		throw rejectWithValue('Не удалось загрузить статистику консультаций.');
	}
});

export const getOrdersStatistics = createAsyncThunk<
	Statistics[],
	reqStatistics,
	{ rejectValue: string }
>('statistics/orders', async ({ mode, date }, { rejectWithValue }) => {
	try {
		const response =
			mode === 'year'
				? await statisticsService.getStoreYearStatistics(date)
				: await statisticsService.getStoreMounthStatistics(date);

		return response.data;
	} catch (e) {
		throw rejectWithValue('Не удалось загрузить статистику билетов с использованием промокода.');
	}
});
